/**
 * @description 静态级别配置 staticConfig
 * @author libaiqi
 * @date 2019/1/25
 */

import Logic from '../logic-base'

const staticConfigBiz = new Logic()

staticConfigBiz.deleteStaticConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteStaticConfig,
    data: data
  })
}

staticConfigBiz.getStaticConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getStaticConfig,
    data: data
  })
}

staticConfigBiz.updateStaticConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.updateStaticConfig,
    data: data
  })
}

staticConfigBiz.addStaticConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addStaticConfig,
    data: data
  })
}

staticConfigBiz.getHostIps = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getHostIps,
    data: data
  })
}

export default staticConfigBiz
